/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/235-grin2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zm3 3.688a1.815 1.815 0 011.788 2.115.312.312 0 01-.616 0c-.096-.573-.589-.833-1.171-.833s-1.074.26-1.171.833a.312.312 0 01-.616 0 1.815 1.815 0 011.788-2.115zm-6 0a1.815 1.815 0 011.788 2.115.312.312 0 01-.616 0c-.096-.573-.589-.833-1.171-.833s-1.074.26-1.171.833a.312.312 0 01-.616 0 1.815 1.815 0 011.788-2.115zM3 9h3v3.873A4.017 4.017 0 013 9zm4 4V9h2v4H7zm3-.127V9h3a4.017 4.017 0 01-3 3.873z"/>'
  }
})
